import React, { useContext } from "react";
import PageBanner from "../components/PageBanner";
import { LanguageContext } from "../LanguageContext";

const Privacy = () => {
  const { language } = useContext(LanguageContext);
  return (
    <>
      <PageBanner />
      <div className={`container pt-5 ${language === "ar" ? "rtl" : ""}`}>
        <div className=" row ">
          <div className="privacy-main-header">
            {language === "ar" ? "سياسة الخصوصية" : "PRIVACY POLICY"}
          </div>
          <p className="privacy-content">
            {language === "ar"
              ? "تاريخ السريان: 1 أكتوبر 2026"
              : "Effective Date: 1 October 2026"}
          </p>
          <div className="privacy-sub-title">
            {language === "ar"
              ? "مرحبًا بك في وان فوريفر!"
              : "Welcome to onefurever!"}
          </div>
          <p className="privacy-content">
            {language === "ar"
              ? 'وان فوريفر يقدر خصوصيتك، وتوضح سياسة الخصوصية هذه كيف يقوم تطبيق "وان فوريفر" للجوال ومواقع الويب المرتبطة به  www.onefurever.net يشار إليها مجتمعة باسم )"التطبيق"، "OneFurever"، "الموقع"، "نحن"، "لنا" أو "المنصة("  بجمع معلومات عنك عندما تزور موقعنا على الويب أو تطبيق الهاتف المحمول وتستخدم الخدمات المتاحة على المنصة ("الخدمات")، وكيف نستخدم هذه المعلومات ونكشف عنها.'
              : "OneFurever values your privacy, this Privacy Policy explains how “OneFurever” mobile application and its related websites www.onefurever.net (collectively the the'App', 'OneFurever', 'site', 'we', 'us', 'our' or 'platform' ), collects information about you when you visit our website or mobile application and use the services available on the Platform (\"Services\"), and how we use and disclose that information."}
          </p>
          <p className="privacy-content">
            {language === "ar"
              ? "باستخدامك لتطبيق وان فوريفر والخدمات المرتبطة به، فإنك تقر بأنك قد قرأت وفهمت ووافقت على الممارسات الموضحة في سياسة الخصوصية هذه. نشجعك على مراجعتها بعناية لفهم حقوقك ومسؤولياتنا فيما يتعلق بالتعامل مع بياناتك."
              : "By using the OneFurever app and services, you acknowledge that you have read, understood, and agreed to the practices described in this Privacy Policy. We encourage you to review it carefully to understand your rights and our responsibilities when it comes to handling your data."}
          </p>
          <p className="privacy-content">
            {language === "ar"
              ? "هدفنا هو تقديم تجربة آمنة وسلسة وشخصية تتيح لك الاستفادة الكاملة من تطبيقنا، مع الالتزام بأعلى معايير الخصوصية. إذا كانت لديك أي أسئلة أو مخاوف بخصوص هذه السياسة، فلا تتردد في التواصل معنا."
              : "Our goal is to provide a secure, seamless, and personalized experience that allows you to enjoy the full benefits of our app while maintaining the highest standards of privacy. If you have any questions or concerns regarding this policy, please do not hesitate to contact us."}
          </p>
        </div>
        <div className=" row ">
          <div className="privacy-main-header">
            {language === "ar"
              ? "1 . المعلومات التي نجمعها."
              : "1. INFORMATION WE COLLECT."}
          </div>
          <p className="privacy-content">
            {language === "ar"
              ? "نقوم بجمع البيانات لتقديم خدمات عالية الجودة، وضمان عمل التطبيق بكفاءة، وتحسين تجربة المستخدم. يشمل ذلك:"
              : "We collect data to provide high-quality services, ensure app functionality, and improve user experience. This includes:"}
          </p>
          <div className="privacy-sub-title">
            {language === "ar"
              ? "1-1 المعلومات الشخصية"
              : "1.1 Personal Information"}
          </div>
          <p className="privacy-content">
            {language === "ar"
              ? "يتعين على مستخدمي التطبيق إنشاء حساب للوصول إلى أجزاء معينة من منصتنا. يختلف نوع المعلومات الشخصية التي نجمعها بناءً على تفاعلك المحدد مع منصتنا."
              : "app users are required to create an account to be able to access certain portions of our Platform, The type of personal information that we collect from you varies based on your particular interaction with our Platform."}
          </p>
          <p className="privacy-content">
            {language === "ar"
              ? "أثناء عملية تسجيل الحساب، سنجمع معلومات مثل اسمك، وعنوان بريدك الإلكتروني أو رقم هاتفك، وقد نجمع المعلومات الشخصية التي تنشرها على ملفك الشخصي، أو ملاحظاتك، وأي تعليقات أو مناقشات تنشرها عبر تطبيقنا."
              : "During the Account registration process, we will collect information such as your name and email address or your phone number, and We may also collect personal information that you post on your Profile, or Feedback, and any comments or discussions you post via our app."}
          </p>
          <p className="privacy-content">
            {language === "ar"
              ? "نجمع التفاصيل التالية عند التسجيل أو استخدام التطبيق أو التفاعل مع خدماتنا:"
              : "We collect the following details when you register, use our app, or interact with our services:"}
          </p>
          <ul>
            <li>
              {language === "ar"
                ? "بيانات الهوية والتحقق من الحساب: الاسم الحقيقي للمستخدم، البريد الإلكتروني، رقم الهاتف، وصور الملف الشخصي. يشمل ذلك أيضاً بياناتك الشخصية الحساسة وفقاً للقانون المصري رقم 151 لسنة 2020، والتي نجمعها حصرياً أثناء عملية التحقق من الحساب المكونة من 3 خطوات، وهي: صورة فوتوغرافية حية للوجه (\"سيلفي\") يتم التقاطها عبر كاميرا جهازك، مسح ضوئي مباشر لبطاقة الرقم القومي المصرية أو جواز السفر، ورقم الهوية الذي يدخله المستخدم يدوياً."
                : "Identity & Verification Data: Email address, phone number, real name, and profile pictures. It also includes your Sensitive Personal Data under Egyptian Law No. 151 of 2020, collected strictly during our three-step identity verification process: a real-time facial photograph (\"selfie\") taken via your device's camera, a live scan of your official Egyptian National ID card or Passport, and the manually entered document number."}
            </li>
            <li>
              {language === "ar"
                ? " بيانات الحساب:  اسم المستخدم، كلمة المرور."
                : "Account Data: Username, password"}
            </li>
            <li>
              {language === "ar"
                ? "معلومات ديموغرافية:  (على سبيل المثال، الجنس وتاريخ الميلاد والتعليم والمعلومات الأخرى ذات الصلة باستبيانات المستخدم والعروض)."
                : "demographic information (e.g., gender, date of birth, education, and other information relevant to user surveys and/or offers)."}
            </li>
            <li>
              {language === "ar"
                ? 'حسابات"أبل" و"جوجل" : يمكنك تسجيل الدخول إلى منصتنا من خلال حساب "أبل"  أو "جوجل" الخاص بك. سنطلب منك منحنا الإذن للوصول إلى معلوماتك الأساسية على "أبل" أو "جوجل"  (بما في ذلك عنوان بريدك الإلكتروني واسمك). إذا سمحت لنا بالوصول إلى هذه المعلومات، فسيكون لدينا إمكانية الوصول إليها حتى إذا اخترت عدم جعل هذه المعلومات عامة. نقوم بتخزين المعلومات التي نتلقاها من "أبل" "جوجل" مع المعلومات الأخرى التي نجمعها منك أو نتلقاها عنك."أبل" "جوجل"  يتحكمان في المعلومات التي يجمعانها منك. لمزيد من المعلومات حول كيفية استخدام "أبل" و"جوجل"  لمعلوماتك والإفصاح عنها، بما في ذلك أي معلومات تجعلها عامة، يرجى الرجوع إلى سياسة الخصوصية الخاصة بـ "أبل" و"جوجل" . ليس لدينا أي سيطرة على كيفية استخدام أو إفشاء أي موقع طرف ثالث للمعلومات الشخصية التي يجمعها عنك.'
                : "Apple & google accounts: You may log into our Platform through your apple or google account. We will ask that you grant us permission to access and collect your apple or google basic information (this includes your email address, name). If you allow us to have access to this information, then we will have access to this information even if you have chosen not to make that information public. We store the information that we receive from apple & google with other information that we collect from you or receive about you. Apple & google controls the information it collects from you. For information about how apple & google may use and disclose your information, including any information you make public, please consult apple & google privacy policy. We have no control over how any third party site uses or discloses the personal information it collects about you."}
            </li>
          </ul>
          <p className="privacy-content">
            {language === "ar"
              ? "قد نجمع أيضًا المعلومات الشخصية التي تنشرها في عروضك، ملفك الشخصي، أو ملاحظاتك، وأي تعليقات أو مناقشات تنشرها في غرف الدردشة  المفتوحة، أو مواقع المراسلة الأخرى على المنصة."
              : "We may also collect personal information that you post in your Posts, Profile, or Feedback, and any comments or discussions you post in any open chat rooms, or other correspondence site on the Platform."}
          </p>
          <div className="privacy-sub-title">
            {language === "ar"
              ? "1-2 معلومات الموقع"
              : "1.2 Location Information"}
          </div>
          <p className="privacy-content">
            {language === "ar"
              ? "بموافقتك، نقوم بجمع ما يلي:"
              : "With your consent, we collect:"}
          </p>
          <p className="privacy-content">
            {language === "ar"
              ? "معلومات الموقع الجغرافي: نظام تحديد المواقع (جي بي أس) الخاص بجهازك المحمول (لتقديم تجربة مستخدم محسّنة)،معظم الأجهزة المحمولة تتيح للمستخدم التحكم أو تعطيل استخدام خدمات الموقع للتطبيقات من خلال قائمة إعدادات الجهاز."
              : "Geo-location Information -mobile device’s GPS (to offer an improved User’s experience), most mobile devices allow the User to control or disable the use of location services for applications in the device’s settings menu."}
          </p>
          <div className="privacy-sub-title">
            {language === "ar"
              ? "1-3 بيانات الحيوانات الأليفة"
              : "1.3 Pet-Specific Data"}
          </div>
          <p className="privacy-content">
            {language === "ar"
              ? "يمكنك اختيارياً تقديم تفاصيل حول حيواناتك الأليفة، بما في ذلك:"
              : "You may optionally provide details about your pets, including:"}
          </p>
          <ul>
            <li>
              {language === "ar"
                ? "الاسم، السلالة، العمر، النوع، اللون، السجلات الصحية، والتفضيلات للخدمات المتعلقة بالحيوانات الأليفة."
                : "Name, breed, age, kind, color, health records, and preferences for pet-related services."}
            </li>
          </ul>
          <div className="privacy-sub-title">
            {language === "ar"
              ? "1-4 بيانات التواصل والدعم"
              : "1.4 Communication and Support Data"}
          </div>
          <p className="privacy-content">
            {language === "ar"
              ? "إذا تواصلت معنا، نقوم بجمع:"
              : "If you contact us, we collect:"}
          </p>
          <ul>
            <li>
              {language === "ar"
                ? "رسائل البريد الإلكتروني، الرسائل، وسجلات التفاعلات مع خدمة العملاء."
                : "Emails, messages, and records of customer service interactions."}
            </li>
            <li>
              {language === "ar"
                ? "الملاحظات، التقييمات، وإجابات الاستبيانات."
                : "Feedback, reviews, and survey responses."}
            </li>
          </ul>
          <div className="privacy-sub-title">
            {language === "ar" ? "1-5 بيانات الاستخدام" : "1.5 Usage Data"}
          </div>
          <p className="privacy-content">
            {language === "ar"
              ? "معلومات حول تفاعلاتك مع التطبيق، مثل:"
              : "Information about your interactions with the app, such as:"}
          </p>
          <ul>
            <li>
              {language === "ar"
                ? "الميزات التي تم الوصول إليها، مدة الجلسات، والإجراءات التي تم تنفيذها داخل التطبيق."
                : "Features accessed, session duration, and actions performed within the app."}
            </li>
          </ul>
          <div className="privacy-main-header">
            {language === "ar"
              ? "2  كيف نستخدم معلوماتك"
              : "2. HOW WE USE YOUR INFORMATION."}
          </div>
          <p className="privacy-content">
            {language === "ar"
              ? "نستخدم المعلومات التي نجمعها لتحقيق الأغراض التالية:"
              : "We use the information we collect to:"}
          </p>
          <div className="privacy-sub-title">
            <ul>
              <li>
                {language === "ar"
                  ? "تقديم الخدمات وإدارتها"
                  : "Provide and Manage Services"}
              </li>
            </ul>
          </div>
          <p className="privacy-content">
            {language === "ar"
              ? "جمع معلوماتك الشخصية والمعلومات المجمعة حول استخدام منصتنا وخدماتنا لفهم احتياجاتك بشكل أفضل وتقديم تجربة منصة محسّنة. على وجه التحديد، قد نستخدم معلوماتك الشخصية لأي من الأسباب التالية:"
              : "We collect your personal information and aggregate information about the use of our Platform and Services to better understand your needs and to provide you with a better Platform experience. Specifically, we may use your personal information for any of the following reasons:"}
          </p>
          <div className="privacy-sub-title">
            {language === "ar"
              ? "أ- لتقديم خدماتنا إليك"
              : "A- To provide our Services to you"}
          </div>
          <p className="privacy-content">
            {language === "ar"
              ? "، بما في ذلك تسجيلك في خدماتنا، التحقق من هويتك وصلاحيتك لاستخدام خدماتنا، وتمكينك من استخدام منصتنا وخدماتنا بشكل عام."
              : "including registering you for our Services, verifying your identity and authority to use our Services, and to otherwise enable you to use our Platform and our Services;"}
          </p>
          <div className="privacy-sub-title">
            {language === "ar"
              ? "ب- تحسين تجربة المستخدم وبحوث السوق"
              : "B- Enhance User Experience and market research"}
          </div>
          <ul>
            <li>
              {language === "ar"
                ? "تحليل سلوك المستخدم لتحسين وصيانة منصتنا وخدماتنا."
                : "Analyze user behavior to improve and maintain our Platform and our Services."}
            </li>
            <li>
              {language === "ar"
                ? "تخصيص المحتوى، التوصيات، والإشعارات."
                : "Customize content, recommendations, and notifications."}
            </li>
            <li>
              {language === "ar"
                ? "• لأغراض استكشاف الأخطاء وإصلاحها، عند الاقتضاء .قد نستخدم معلوماتك الديموغرافية (مثل العمر، عناوين السكن، والبيانات الأخرى المتنوعة) لتسهيل الترويج للخدمات بشكل أكثر فعالية للجماهير المستهدفة المناسبة ولأغراض البحث والتحليل الأخرى."
                : "For trouble-shooting purposes, where applicable. We may use your demographic information (i.e., age, residential addresses, and other various data) to more effectively facilitate the promotion of services to appropriate target audiences and for other research and analytical purposes."}
            </li>
            <li>
              {language === "ar"
                ? 'لأغراض بحوث السوق الخاصة ب"وان فوريفر".'
                : "For OneFurever market research purposes."}
            </li>
          </ul>
          <div className="privacy-sub-title">
            {language === "ar" ? "ج- التواصل معك" : "C- Communicate with You"}
          </div>
          <ul>
            <li>
              {language === "ar"
                ? "لدعم العملاء والرد على استفساراتك."
                : "For customer support and to respond to your inquiries."}
            </li>
            <li>
              {language === "ar"
                ? 'إبلاغك بالميزات الجديدة، التحديثات، أو العروض الترويجية. (نقوم بإرسال رسائل بريد إلكتروني ترويجية بشكل دوري إلى عنوان البريد الإلكتروني الذي تقدمه بخصوص الخدمات الجديدة، العروض الخاصة، والمعلومات الأخرى المتعلقة بـ "وان فوريفر" التي نعتقد أنها قد تهمك).'
                : "Notify you of new features, updates, or promotional offers. ( we periodically send promotional emails to the email address you provide regarding new services, special offers and other information about OneFurever that we think you may find interesting."}
            </li>

            <li>
              {language === "ar"
                ? "للتواصل معك عبر البريد الإلكتروني، الهاتف، أو، عند الطلب، عبر الرسائل النصية، لتقديم بعض الخدمات أو المعلومات التي طلبتها."
                : "To contact you via email, telephone, or, where requested, by text message, to deliver certain services or information you have requested."}
            </li>
          </ul>
          <div className="privacy-sub-title">
            {language === "ar"
              ? "د-  ضمان الأمان والامتثال"
              : "D- Ensure Security and Compliance"}
          </div>
          <ul>
            <li>
              {language === "ar"
                ? "منع الوصول غير المصرح به، الأنشطة الاحتيالية، وإساءة استخدام خدماتنا."
                : "Prevent unauthorized access, fraudulent activities, and abuse of our services."}
            </li>
            <li>
              {language === "ar"
                ? "الامتثال للمتطلبات القانونية والتنظيمية المعمول بها في مصر."
                : "Comply with applicable legal and regulatory requirements in Egypt."}
            </li>

            <li>
              {language === "ar"
                ? "لأغراض حفظ السجلات الداخلية."
                : "For internal record-keeping purposes."}
            </li>
            <li>
              {language === "ar"
                ? "لحل النزاعات، وحماية أنفسنا ومستخدمي منصتنا وخدماتنا الآخرين، وفرض شروط الاستخدام الخاصة بنا."
                : "To resolve disputes, to protect ourselves and other users of our Platform and Services, and to enforce our Terms of Use."}
            </li>
            <li>
              {language === "ar"
                ? "قد نقوم أيضًا بمقارنة المعلومات الشخصية التي تم جمعها من خلال المنصة والخدمات للتحقق من دقتها مع المعلومات الشخصية التي تم جمعها من أطراف ثالثة؛ وقد نقوم بدمج البيانات المجمعة مع المعلومات الشخصية التي نجمعها عنك."
                : "We also may compare personal information collected through the Platform and Services to verify its accuracy with personal information collected from third parties; and We may combine aggregate data with the personal information we collect about you."}
            </li>
          </ul>
          <div className="privacy-sub-title">
            {language === "ar" ? "و- التحقق" : "E- verification."}
          </div>
          <ul>
            <li>
              {language === "ar"
                ? "و- التحقق والأمان: نقوم بمعالجة بيانات التحقق الحساسة الخاصة بك بناءً على موافقتك الصريحة، والتي تمنحها لنا عند بدء خطوات التحقق داخل التطبيق. يقوم فريقنا الداخلي المختص بمراجعة صورتك الشخصية وصورة الهوية يدوياً فقط للتأكد من هويتك، ومنع الاحتيال، ومنع تكرار الحسابات، ولضمان الأمان العام لمجتمع الحيوانات الأليفة الخاص بنا. لن يتم استخدام هذه البيانات الحساسة مطلقاً لأغراض التسويق، أو التنميط، أو الإعلانات الموجهة، أو أي أغراض تجارية ثانوية أخرى."
                : "E- Verification & Security: We process your sensitive verification data based entirely on your explicit consent, which you grant by initiating the verification steps inside the App. Our authorized internal team manually reviews your selfie and ID scan strictly to confirm your identity, prevent fraud, stop account duplication, and ensure the safety of our pet community ecosystem. This data will never be used for marketing, profiling, behavioral advertising, or any secondary commercial purposes."}
            </li>
          </ul>
          <div className="privacy-main-header">
            {language === "ar"
              ? "3 مشاركة المعلومات"
              : "3 INFORMATION SHARING."}
          </div>
          <p className="privacy-content">
            {language === "ar"
              ? "لا نشارك معلوماتك إلا عند الضرورة ومع الأطراف الثالثة الموثوقة:"
              : "We share your information only as necessary and with trusted third parties:"}
          </p>
          <div className="privacy-sub-title">
            {language === "ar" ? "3-1 مقدمو الخدمات" : "3.1 Service Providers"}
          </div>
          <p className="privacy-content">
            {language === "ar"
              ? "نعمل مع جهات خارجية من الأطراف الثالثة من أجل:"
              : "We work with third-party vendors for:"}
          </p>
          <ul>
            <li>
              {language === "ar"
                ? "خدمات التخزين والاستضافة السحابية."
                : "Cloud storage and hosting services."}
            </li>
            <li>
              {language === "ar"
                ? "التحليلات لفهم سلوك المستخدم وتحسين أداء التطبيق."
                : "Analytics to understand user behavior and improve app performance."}
            </li>
          </ul>
          <div className="privacy-sub-title">
            {language === "ar"
              ? "٣-١-١ الإعلانات، والتحليلات، وقياس عمليات التثبيت (AppsFlyer):"
              : "3.1.1 Advertising, Analytics, and Install Measurement (AppsFlyer):"}
          </div>
          <p className="privacy-content">
            {language === "ar"
              ? "نحن نستخدم خدمة  AppsFlyer، وهي خدمة تحليلات وقياس مخصصة للهواتف المحمولة تقدمها شركة .AppsFlyer Ltd، لفهم عدد الأشخاص الذين يقومون بتثبيت وفتح تطبيقوانفوريفر ولمقياس أداء حملاتنا التسويقية."
              : "We use AppsFlyer, a mobile measurement and analytics service provided by AppsFlyer Ltd., to understand how many people install and open the OneFurever app and to measure the performance of our marketing."}
          </p>
          <p className="privacy-content">
            {language === "ar"
              ? "ما تتلقاه خدمة AppsFlyer من التطبيق:"
              : "What AppsFlyer receives from the app:"}
          </p>
          <ul>
            <li>
              {language === "ar"
                ? "معرفات الأجهزة: معرف الإعلانات من جوجل (Google Advertising ID) على أجهزة أندرويد، وعلى أجهزة iOS معرف الإعلانات (IDFA) فقط إذا سمحت بالتتبع عند سؤالك، بالإضافة إلى معرف البائعين (IDFV)."
                : "Device identifiers: The Google Advertising ID on Android, and on iOS the Identifier for Advertisers (IDFA) only if you allow tracking when asked, together with the Identifier for Vendors (IDFV)."}
            </li>
            <li>
              {language === "ar"
                ? "المعلومات التقنية: طراز الجهاز، إصدار نظام التشغيل، إصدار التطبيق، اللغة، عنوان الـ IP، والدولة التقريبية المستنتجة منه."
                : "Technical information: Device model, operating system version, app version, language, IP address, and approximate country derived from it."}
            </li>
            <li>
              {language === "ar"
                ? "نشاط التطبيق: التشغيل الأول للتطبيق بعد التثبيت وعمليات فتح التطبيق اللاحقة."
                : "App activity: The first launch of the app after installation and later app openings."}
            </li>
            <li>
              {language === "ar"
                ? "ربط الحساب: معرف حسابك على وانفوريفر عندما تكون مسجلاً الدخول، بحيث يمكن ربط عمليات التثبيت والجلسات بحسابك."
                : "Account Sync: Your OneFurever account identifier when you are signed in, so that installs and sessions can be linked to an account."}
            </li>
          </ul>



          <p className="privacy-content">
            {language === "ar"
              ? "تقوم AppsFlyer بمعالجة هذه البيانات نيابة عنا ووفقاً لتعليماتنا، ولا تستخدمها لأغراضها الخاصة. قد يتم تخزين البيانات ومعالجتها على خوادم AppsFlyer الموجودة خارج دولتك، بما في ذلك الاتحاد الأوروبي والولايات المتحدة، مع وجود ضمانات حماية مناسبة."
              : "AppsFlyer processes this data on our behalf and under our instructions, and does not use it for its own purposes. Data may be stored and processed on AppsFlyer servers located outside your country, including in the European Union and the United States, with appropriate safeguards in place."}
          </p>
          <p className="privacy-content">
            {language === "ar"
              ? "خياراتك والتحكم في بياناتك:"
              : "Your choices:"}
          </p>
          <ul>
            <li>
              {language === "ar"
                ? "على أجهزة iOS، يمكنك رفض طلب \"السماح بالتتبع\"، أو تغيير اختيارك في أي وقت من خلال الإعدادات < الخصوصية والأمن< التتبع."
                : "On iOS, you can decline the \"Allow tracking\" prompt, or change your choice at any time in Settings > Privacy & Security > Tracking."}
            </li>
            <li>
              {language === "ar"
                ? "على أجهزة أندرويد، يمكنك حذف أو إعادة تعيين معرف الإعلانات الخاص بك من خلال الإعدادات < Google < الإعلانات."
                : "On Android, you can delete or reset your advertising ID in Settings > Google > Ads."}
            </li>
            <li>
              {language === "ar"
                ? "يمكنك أن تطلب منا حذف البيانات التي تحتفظ بها AppsFlyer عن جهازك عن طريق إرسال بريد إلكتروني إلى support@onefurever.net.  وسنقوم بتوجيه الطلب إلى AppsFlyer وتأكيد إتمامه لك."
                : "You can ask us to delete the data AppsFlyer holds about your device by emailing support@onefurever.net. We will forward the request to AppsFlyer and confirm when it is done. (Note: I updated the email to match your support email)."}
            </li>
            <li>
              {language === "ar"
                ? "ربط الحساب: معرف حسابك على وانفوريفر عندما تكون مسجلاً الدخول، بحيث يمكن ربط عمليات التثبيت والجلسات بحسابك."
                : "Account Sync: Your OneFurever account identifier when you are signed in, so that installs and sessions can be linked to an account."}
            </li>
          </ul>
          <p className="privacy-content">
            {language === "ar"
              ? "سياسة الخصوصية الخاصة بـ AppsFlyer متاحة عبر الرابط التالي: appsflyer.com/legal/services-privacy-policy"
              : "AppsFlyer's own privacy policy is available at: appsflyer.com/legal/services-privacy-policy"}
          </p>
          <div className="privacy-sub-title">
            {language === "ar"
              ? "3-2 الالتزامات القانونية"
              : "3.2 Legal Obligations"}
          </div>
          <p className="privacy-content">
            {language === "ar"
              ? "قد نفصح عن المعلومات للامتثال لما يلي:"
              : "We may disclose information to comply with:"}
          </p>
          <ul>
            <li>
              {language === "ar"
                ? "أوامر المحاكم، الإجراءات القانونية، أو طلبات تطبيق القانون."
                : "Court orders, legal processes, or law enforcement requests."}
            </li>
            <li>
              {language === "ar"
                ? "اللوائح المعمول بها في عملياتنا."
                : "Regulations applicable to our operations."}
            </li>
          </ul>
          <div className="privacy-sub-title">
            {language === "ar"
              ? "3-4 البيانات المجهولة"
              : "3.4 Anonymized Data"}
          </div>
          <p className="privacy-content">
            {language === "ar"
              ? "قد نستخدم أو نشارك البيانات المجمعة والمجهولة  الهوية لأغراض البحث أو التحليل أو التسويق."
              : "We may use or share aggregated, anonymized data for research, analytics, or marketing purposes."}
          </p>
          <div className="privacy-main-header">
            {language === "ar" ? "4 احتفاظ البيانات" : "4 DATA RETENTION."}
          </div>
          <p className="privacy-content">
            {language === "ar"
              ? "نحتفظ ببياناتك طالما كان ذلك ضروريًا لتحقيق الأغراض الموضحة في سياسة الخصوصية هذه أو كما يقتضي القانون."
              : "We retain your data as long as necessary to fulfill the purposes outlined in this Privacy Policy or as required by law."}
          </p>
          <div className="privacy-sub-title">
            {language === "ar" ? "4-1 بيانات الحساب" : "4.1 Account Data"}
          </div>
          <p className="privacy-content">
            {language === "ar"
              ? "تُحتفظ البيانات الشخصية حتى يتم حذف حسابك أو يصبح غير نشط لفترة محددة."
              : "Personal data is retained until your account is deleted or inactive for a specified period."}
          </p>
          <div className="privacy-sub-title">
            {language === "ar"
              ? "4-2 بيانات التواصل"
              : "4.2 Communication Data"}
          </div>
          <p className="privacy-content">
            {language === "ar"
              ? "يتم الاحتفاظ بتفاعلات خدمة العملاء وردود الفعل لتحسين خدماتنا."
              : "Customer service interactions and feedback are retained for improving our services."}
          </p>
          <div className="privacy-sub-title">
            {language === "ar"
              ? "4.3 الاحتفاظ ببيانات التحقق وحذفها"
              : "4.3 Verification Data Retention & Deletion"}
          </div>
          <p className="privacy-content">
            {language === "ar"
              ? "التزاماً بمبدأ الحد من تخزين البيانات وفقاً للقانون المصري، فإننا لا نقوم بتخزين مستنداتك الحساسة بشكل دائم. بمجرد قيام فريقنا الداخلي بمراجعة طلب التحقق الخاص بك والموافقة عليه أو رفضه يدوياً، يتم حذف الصور الأصلية لصورتك الشخصية (السيلفي) والمسح الضوئي لبطاقة الهوية/جواز السفر نهائياً وبشكل آمن من أنظمة التخزين لدينا خلال ثلاثين (30) يوماً. بعد هذا الحذف، نحتفظ فقط بحالة حسابك (مُوثق)، واسمك الحقيقي الموثق، ونسخة مشفرة من رقم الهوية وذلك فقط لمنع استخدام نفس المستند الفعلي لإنشاء حسابات وهمية أو احتيالية أخرى."
              : "In accordance with data minimization principles, your raw sensitive documents are not stored permanently. Once our internal team manually reviews and successfully approves or rejects your identity verification request, the raw images of your selfie and your ID/Passport scan are permanently and securely deleted from our storage systems within thirty (30) days. Following this deletion, we retain only your verified account status, your verified real name, and a securely encrypted/hashed version of your ID number to prevent the same physical document from being reused for fraudulent accounts."}
          </p>
          <div className="privacy-main-header">
            {language === "ar" ? "5 أمان البيانات" : "5 DATA SECURITY."}
          </div>
          <div className="privacy-sub-title">
            {language === "ar"
              ? "نقوم بتنفيذ تدابير أمان معتمدة في الصناعة لحماية معلوماتك، بما في ذلك:"
              : "We implement industry-standard security measures to protect your information, including:"}
          </div>
          <ul>
            <li>
              {language === "ar"
                ? "التشفير: يتم تشفير البيانات الحساسة أثناء النقل والتخزين لمنع الوصول غير المصرح به."
                : "Encryption: Sensitive data is encrypted during transmission and storage to prevent unauthorized access."}
            </li>
            <li>
              {language === "ar"
                ? "التدقيقات المنتظمة: نقوم بإجراء تدقيقات أمنية دورية وتقييمات للثغرات لتحديد المخاطر المحتملة ومعالجتها."
                : "Regular Audits: We conduct regular security audits and vulnerability assessments to identify and address potential risks."}
            </li>
            <li>
              {language === "ar"
                ? "المصادقة الآمنة: تم تنفيذ بروتوكولات مصادقة متقدمة لضمان أن المستخدمين المصرح لهم فقط يمكنهم الوصول إلى حسابك."
                : "Secure Authentication: Advanced authentication protocols are in place to ensure only authorized users can access your account."}
            </li>
          </ul>
          <p className="privacy-content">
            {language === "ar"
              ? "ثقتك مهمة بالنسبة لنا، ونحن ملتزمون بالحفاظ على أعلى معايير الأمان. إذا كنت تشك في أي وصول غير مصرح به أو اختراق أمني، يرجى الاتصال بنا على الفور حتى نتمكن من اتخاذ إجراءات سريعة لمعالجة المشكلة."
              : "Your trust is important to us, and we are committed to maintaining the highest standards of security. If you suspect any unauthorized access or a security breach, please contact us immediately so we can take prompt action to address the issue."}
          </p>
          <div className="privacy-main-header">
            {language === "ar"
              ? "6 حقوقك واختياراتك"
              : "6 YOUR RIGHTS AND CHOICES."}
          </div>
          <p className="privacy-content">
            {language === "ar"
              ? "نمنحك التحكم الكامل على معلوماتك، بما في ذلك:"
              : "We provide you with control over your information, including:"}
          </p>
          <div className="privacy-sub-title">
            {language === "ar"
              ? "6-1 الوصول إلى المعلومات وتحديثها"
              : "6.1 Access and Update Information"}
          </div>
          <ul>
            <li>
              {language === "ar"
                ? "يمكنك عرض أو تعديل تفاصيلك الشخصية عبر إعدادات حسابك."
                : "View or edit your personal details via your account settings."}
            </li>
          </ul>
          <div className="privacy-sub-title">
            {language === "ar" ? "6-2 حذف حسابك" : "6.2 Delete Your Account"}
          </div>
          <p className="privacy-content">
            {language === "ar"
              ? "لديك التحكم الكامل في حسابك ويمكنك حذفه في أي وقت. لحذف حسابك والبيانات المرتبطة به:"
              : "You have full control over your account and can delete it at any time. To delete your account and associated data:"}
          </p>
          <ul>
            <li>
              {language === "ar"
                ? "انتقل إلى إعدادات الملف الشخصي داخل التطبيق."
                : "Go to your Profile Settings within the app."}
            </li>
            <li>
              {language === "ar"
                ? 'اختر خيار "حذف حسابي".'
                : "Select the Delete My Account option."}
            </li>
            <li>
              {language === "ar"
                ? "أكد اختيارك، وسيتم حذف حسابك وجميع البيانات المرتبطة به بشكل دائم."
                : "Confirm your choice, and your account and all associated data will be permanently deleted."}
            </li>
          </ul>
          <p className="privacy-content">
            {language === "ar"
              ? "إذا واجهت أي مشاكل أو كنت بحاجة إلى المساعدة، فإن فريق الدعم لدينا متاح للمساعدة."
              : "If you encounter any issues or need assistance, our support team is available to help."}
          </p>
          <div className="privacy-sub-title">
            {language === "ar"
              ? "6-3 صلاحيات الموقع"
              : "6.3 Location Permissions"}
          </div>
          <ul>
            <li>
              {language === "ar"
                ? "يمكنك تمكين أو تعطيل تتبع الموقع عبر إعدادات جهازك."
                : "Enable or disable location tracking via your device settings."}
            </li>
          </ul>
          <div className="privacy-main-header">
            {language === "ar"
              ? "7 استطلاعات الرأى والاستبيانات"
              : "7. POLLS AND SURVEYS."}
          </div>
          <p className="privacy-content">
            {language === "ar"
              ? "وفقًا لتقديرنا الخاص، قد يقدم وان فوريفر أيًا من الخدمات المجانية التالية على المنصة، والتي يمكنك اختيار استخدامها أو تلقيها حسب اختيارك. قد يتطلب بعض من هذه الخدمات منك تقديم معلومات شخصية إضافية كما هو موضح أدناه:"
              : "At our sole discretion, OneFurever may offer any of the following free services on the Platform, which you may select to use or receive at your option. Certain of the following services may require you to provide additional personal information as detailed below:"}
          </p>
          <div className="privacy-sub-title">
            {language === "ar" ? "7-1 استطلاعات الرأى" : "7.1 polling"}
          </div>
          <p className="privacy-content">
            {language === "ar"
              ? 'قد نقدم استطلاعات رأى تفاعلية للمستخدمين حتى يتمكنوا من مشاركة آرائهم بسهولة مع المستخدمين الآخرين ومعرفة ما يفكر فيه جمهورنا بشأن القضايا المهمة، والخدمات، و المنصة. يتم تجميع الآراء أو الردود الأخرى على استطلاعات الرأى ولا يمكن التعرف عليها من قبل أي مستخدم معين. قد نستخدم نظامًا " لوضع علامة " المستخدمين بعد أن يصوتوا، بحيث يمكنهم التصويت مرة واحدة فقط على سؤال معين. لا ترتبط هذه العلامة بمعلومات حول المستخدمين الأفراد.'
              : 'We may offer interactive polls to users so they can easily share their opinions with other users and see what our audience thinks about important issues, Services, and/or the Platform. Opinions or other responses to polls are aggregated and are not identifiable to any particular user. We may use a system to "tag" users after they have voted, so they can vote only once on a particular question. This tag is not correlated with information about individual users.'}
          </p>
          <div className="privacy-sub-title">
            {language === "ar" ? "7-2 الاستبيانات" : "7.2 surveys"}
          </div>
          <p className="privacy-content">
            {language === "ar"
              ? "قد نقوم بإجراء استبيانات للمستخدمين من وقت لآخر لتوجيه محتوى المنصة بشكل أفضل إلى مستخدميها. لن نشارك الردود الفردية من هذه الاستبيانات مع أي طرف ثالث. سنشارك البيانات المجمعة مع مقدمي خدمات الطرف الثالث والشركاء وأطراف ثالثة أخرى. كما سنقوم بنشر البيانات المجمعة التي تحتوي على ردود الاستبيانات على منصتنا؛ يمكن للمستخدمين الآخرين في منصتنا الاطلاع على هذه البيانات وتنزيلها."
              : "We may conduct user surveys from time to time to better target our content to our Platform users. We will not share individual responses from these surveys with any third party. We will share aggregate data with third party service providers, partners, and other third parties. We also will post aggregate data containing survey responses on our Platform; that data may be viewed and downloaded by other users of our Platform."}
          </p>
          <div className="privacy-main-header">
            {language === "ar" ? "8 الإفصاح" : "8. DISCLOSURE"}
          </div>
          <p className="privacy-content">
            {language === "ar"
              ? "قد نشارك المعلومات التي نجمعها عنك، بما في ذلك معلوماتك الشخصية، كما يلي:"
              : "We may share the information that we collect about you, including your personal information, as follows:"}
          </p>
          <div className="privacy-sub-title">
            {language === "ar"
              ? "المعلومات المكشوفة لحمايتنا وحماية الآخرين"
              : "8.1 information disclosed to protect us and others"}
          </div>
          <p className="privacy-content">
            {language === "ar"
              ? "قد نفصح عن معلوماتك الشخصية لمنع حدوث حالة طوارئ، أو لحماية أو تنفيذ حقوقنا، أو تنفيذ شروط وأحكامنا، أو لحماية سلامة مستخدمي منصتنا وخدماتنا أو لحماية أو تنفيذ حقوق طرف ثالث، أو كما يقتضي القانون."
              : "We may disclose your personal information to prevent an emergency, protect or enforce our rights, enforce our Terms and conditions and/or to protect the safety of users of our Platform and our Services or protect or enforce the rights of a third party, or as required by law."}
          </p>
          <div className="privacy-sub-title">
            {language === "ar"
              ? "المعلومات المكشوفة لمقدمي الخدمات من جهات خارجية من الأطراف الثالثة و شركاء الأعمال"
              : "8.2 information disclosed to third party service providers and business partners"}
          </div>
          <p className="privacy-content">
            {language === "ar"
              ? 'قد نتعاقد مع أطراف ثالثة مختلفة لتوفير وصيانة المنصة والخدمات وعمليات أعمالنا، وقد يحتاج وان فوريفر إلى مشاركة معلوماتك الشخصية والبيانات والمعلومات المجمعة (يُطلق عليها مجتمعة، "المعلومات") مع هؤلاء البائعين ووكالات الخدمة. لن يحصل البائعون ووكالات الخدمة على أي حق في استخدام معلوماتك الشخصية بما يتجاوز ما هو ضروري للوفاء بالتزاماتهم في تقديم الخدمات لك. إذا أكملت استبيانًا، فقد نشارك معلوماتك أيضًا مع مقدم الاستبيان؛ وإذا قدمنا استبيانًا بالتعاون مع جهة أخرى، فسنقوم أيضًا بالكشف عن النتائج لتلك الجهة.'
              : 'We may contract with various third parties for the provision and maintenance of the Platform, Services and our business operations, and OneFurever may need to share your personal and aggregate information (collectively, "information") with these vendors and service agencies. The vendors and service agencies will not receive any right to use your personal information beyond what is necessary to perform its obligations to provide the Services to you. If you complete a survey, we also may share your information with the survey provider; if we offer a survey in conjunction with another entity, we also will disclose the results to that entity.'}
          </p>
          <div className="privacy-sub-title">
            {language === "ar"
              ? "الإفصاح لأطراف ثالثة غير مرتبطة بهدف تلبية طلبك"
              : "8.3 disclosure to non-affiliated third parties in furtherance of your request"}
          </div>
          <p className="privacy-content">
            {language === "ar"
              ? "قد يتم مشاركة مساهماتك المتعلقة بخدمات الإنقاذ والتبني والخدمات الحيوانات الأليفة المفقودة مع مواقع الويب أو منصات الوسائط الاجتماعية التي تربطنا بها علاقة تعاقدية أو مع موقعنا الإلكتروني أو منصات الوسائط الاجتماعية الخاصة بنا من أجل توفير أقصى عرض لطلبك. سيشمل المنشور على موقع الطرف الثالث تفاصيل طلبك. ومع ذلك، سيكون بإمكان الأشخاص المهتمين النقر على طلبك على هذا الموقع أو المنصة التابعة للطرف الثالث، وسيتم توجيههم إلى منصتنا حيث سيكون لديهم إمكانية الوصول إلى مساهمتك، تمامًا كما يمكن لأي عضو آخر على منصتنا مهتم بمنشورك."
              : "Your request contributions regarding rescue and adoption and lost pet services may be shared with third party websites or social media platforms with whom we have a contractual relationship or our website or social media platform in order to provide your request with maximum exposure. The post on the third party website will include the details of your request. Interested people, however, will be able to click on your request on such third party site or platform , and will be directed to our Platform where they will have access to your contribution, as would any other member on our Platform interested in your post."}
          </p>
          <div className="privacy-sub-title">
            {language === "ar"
              ? "المعلومات التي تم الكشف للمسؤولين القانونيين أو الحكوميين"
              : "8.4 information disclosed to law enforcement or government officials"}
          </div>
          <p className="privacy-content">
            {language === "ar"
              ? "سنقوم بالكشف عن معلوماتك ، بما في ذلك، على سبيل المثال لا الحصر، اسمك، مدينتك، جهتك، رقم هاتفك، عنوان بريدك الإلكتروني، تاريخ معرف المستخدم، تاريخ وبيانات المنشورات، والشكاوى المتعلقة بالاحتيال، إلى سلطات إنفاذ القانون أو المسؤولين الحكوميين الآخرين إذا كان من المطلوب منا القيام بذلك بموجب القانون أو اللوائح أو أي سلطة حكومية أخرى أو بالتعاون مع تحقيق من قبل سلطة حكومية."
              : "We will disclose your information, including, without limitation, your name, city, region, telephone number, email address, user ID history, posts history and data, and fraud complaints, to law enforcement or other government officials if we are required to do so by law, regulation or other government authority or otherwise in cooperation with an investigation of a governmental authority."}
          </p>
          <div className="privacy-sub-title">
            {language === "ar"
              ? "عمليات نقل الأعمال أو الإفلاس"
              : "8.5 Business Transfers or bankruptcy"}
          </div>
          <ul>
            <li>
              {language === "ar"
                ? "أ. في حالة حدوث تغيير الإدارة:"
                : "A-in the event of a change of control."}
              <br />
              {language === "ar"
                ? 'في حال خضوع وان فوريفر لتغيير في الإدارة، بما في ذلك، على سبيل المثال لا الحصر، اندماج أو بيع كل أو معظم أصول وان فوريفر المتعلقة بهذا المنصة أو أي إعادة تنظيم مؤسسية أخرى تشارك فيها  وان فوريفر، وبالتالي يتم دمجها أو الاستحواذ عليها من قبل كيان طرف ثالث ("الجهة المستحوذة - الخليفة")، تحتفظ وان فوريفر بالحق في نقل المعلومات التي جمعناها من مستخدمي المنصة والخدمات إلى هذه الجهة المستحوذة.'
                : 'In the event that OneFurever undergoes a change in control, including, without limitation, a merger or sale of all or substantially all of OneFurever assets to which this Platform relates or other corporate reorganization in which OneFurever participates, and is thus merged with or acquired by a third party entity (a "Successor"), OneFurever hereby reserves the right to transfer the information we have collected from the users of the Platform and/or Services to such Successor.'}
            </li>
            <li>
              {language === "ar"
                ? "ب. في حالة الإفلاس أو إعادة التنظيم:في حالة إفلاس OneFurever، أو إعادة تنظيمها، أو وضعها تحت الحراسة، أو تخصيصها لصالح الدائنين، أو تطبيق قوانين أو مبادئ عدالة تؤثر على حقوق الدائنين بشكل عام، قد لا تتمكن وان فوريفر من التحكم في كيفية نقل أو استخدام أو معالجة معلوماتك. وفي مثل هذه الحالة، تحتفظ وان فوريفر بالحق في نقل المعلومات التي جمعناها من مستخدمي المنصة والخدمات إلى أطراف ثالثة غير تابعة."
                : "B- in the event of OneFurever bankruptcy or reorganization. in the event of OneFurever bankruptcy, reorganization, receivership, or assignment for the benefit of creditors, or the application or laws or equitable principles affecting creditors' rights generally, OneFurever may not be able to control how your information is transferred, used, or treated and reserves the right to transfer the information we have collected from the users of the Platform and/or Services to non-affiliated third parties in such event."}
            </li>
          </ul>
          <div className="privacy-sub-title">
            {language === "ar"
              ? "8-6 المعلومات التي يتم الإفصاح عنها بناءً على طلبك"
              : "8.6 information disclosed at your request"}
          </div>
          <p className="privacy-content">
            {language === "ar"
              ? "قد نقوم بمشاركة معلوماتك الشخصية مع مستخدمين مسجلين آخرين بناءً على طلبك الصريح لإرسال معلوماتك إليهم، أو إذا قدمت موافقتك الصريحة على هذا الإفصاح عند تلقي خدمة معينة. على سبيل المثال، عندما تتعاقد للحصول على خدمة معينة مع مستخدم مسجل آخر، ستقوم وان فوريفر بإرسال إشعار إلى ذلك المستخدم المسجل يتضمن المعلومات الشخصية التي اخترت السماح لـ وان فوريفر بالكشف عنها للمستخدمين الذين تتعاقد معهم."
              : "We may share your personal information with other Registered Users to whom you explicitly ask us to send your information or if you explicitly consent to such disclosure upon receipt of a specific Service. For instance, when you contract for a specific Service with another Registered User, OneFurever will send that Registered User a notice that includes the personal information that you have chosen to allow OneFurever to reveal to users with whom you contract."}
          </p>
          <div className="privacy-main-header">
            {language === "ar"
              ? "9 الروابط إلى المواقع الخارجية"
              : "9 LINKS TO EXTERNAL WEBSITES"}
          </div>
          <p className="privacy-content">
            {language === "ar"
              ? "قد يحتوي المنصة على روابط لمواقع أو موارد خارجية لا تخضع لسيطرة وان فوريفر. لا تُعتبر هذه الروابط تأييدًا من   وان فوريفر  لتلك المواقع الخارجية. وتقر بأن وان فوريفر تقدم هذه الروابط لراحتك فقط، وتوافق كذلك على أن وان فوريفر  ليست مسؤولة عن محتوى هذه المواقع الخارجية. لسنا مسؤولين عن حماية وخصوصية أي معلومات تقدمها أثناء زيارتك لتلك المواقع الخارجية، حيث إن هذه المواقع لا تخضع لهذه السياسة. إن استخدامك لأي موقع خارجي يخضع لشروط الاستخدام وسياسة الخصوصية الخاصة بالموقع المرتبط."
              : "The Platform may contain links to other websites or resources over which OneFurever does not have any control. Such links do not constitute an endorsement by OneFurever of those external websites. You acknowledge that OneFurever is providing these links to you only as a convenience, and further agree that OneFurever is not responsible for the content of such external websites. We are not responsible for the protection and privacy of any information which you provide while visiting such external websites and such sites are not governed by this Policy. Your use of any external website is subject to the terms of use and privacy policy located on the linked to external website."}
          </p>
          <div className="privacy-main-header">
            {language === "ar"
              ? "10 شبكات الإعلانات التابعة لجهات خارجية"
              : "10 THIRD-PARTY AD NETWORKS"}
          </div>
          <p className="privacy-content">
            {language === "ar"
              ? "قد نشارك في شبكات إعلانات تابعة لجهات خارجية قد تعرض إعلانات على مواقع أخرى بناءً على زياراتك لموقعنا الإلكتروني ومواقع أخرى. يتيح لنا هذا ولتلك الجهات استهداف الإعلانات من خلال عرض إعلانات لمنتجات وخدمات قد تكون مهتمًا بها. قد يستخدم مزودو شبكات الإعلانات التابعة لجهات خارجية، والمعلنون، والرعاة، وخدمات قياس حركة الزخم ملفات تعريف الارتباط  (كوكيز)، أو جافا سكريبت، أو إشارات الويب (مثل صور GIF)، أو Flash LSOs، أو تقنيات أخرى لقياس فعالية إعلاناتهم وتخصيص محتوى الإعلانات لك. تخضع ملفات تعريف الارتباط والتقنيات الأخرى المستخدمة من قبل هذه الأطراف لسياسات الخصوصية الخاصة بكل طرف، وليست لهذه السياسة. قد نوفر لهؤلاء المعلنين من الجهات الخارجية معلومات حول استخدامك لموقعنا وخدماتنا، بالإضافة إلى معلومات مجمعة أو غير قابلة للتحديد الشخصي حول زوار موقعنا ومستخدمي خدماتنا."
              : "We may participate in third party ad networks that may display advertisements on other websites based on your visits to our Site as well as other websites. This enables us and these third parties to target advertisements by displaying ads for products and services in which you might be interested. Third party ad network providers, advertisers, sponsors and/or traffic measurement services may use cookies, JavaScript, web beacons (including clear GIFs), Flash LSOs and other technologies to measure the effectiveness of their ads and to personalize advertising content to you. These third party cookies and other technologies are governed by each third party's specific privacy policy, not this one. We may provide these third-party advertisers with information about your usage of our Site and our services, as well as aggregate or non-personally identifiable information about visitors to our Site and users of our service."}
          </p>
          <div className="privacy-main-header">
            {language === "ar"
              ? "11 اسمك الكامل واستخدام معلومات  وان فوريفر"
              : "11 YOUR FULL NAME AND USE OF ONEFUREVER INFORMATION"}
          </div>
          <div className="privacy-sub-title">
            {language === "ar"
              ? "11-1 استخدام المعلومات من  وان فوريفر"
              : "11.1 using information from OneFurever"}
          </div>
          <p className="privacy-content">
            {language === "ar"
              ? "تُتيح المنصة مشاركة معلوماتك الشخصية مع الآخرين من أجل المشاركة في الخدمات أو توفيرها أو استخدامها. يُرجى احترام خصوصية الآخرين. أنت توافق على استخدام معلومات المستخدمين الآخرين فقط في نطاق الخدمات المقدمة عبر المنصة."
              : "The Platform facilitates your sharing of personal information with others in order to participate, provide, and use the Services. Please respect the privacy of others. You agree to use the information of other users only for the Services offered through the Platform."}
          </p>
          <div className="privacy-sub-title">
            {language === "ar"
              ? "11-2 حماية الحساب"
              : "11.2 account protection"}
          </div>
          <p className="privacy-content">
            {language === "ar"
              ? "كلمة المرور الخاصة بك هي المفتاح لحسابك، لا تقم أبدًا بمشاركة كلمة المرور مع أي شخص. إذا قمت بمشاركة كلمة المرور أو معلوماتك الشخصية مع الآخرين، فإنك تتحمل المسؤولية الكاملة عن جميع الإجراءات التي تتم عبر حسابك. إذا فقدت السيطرة على كلمة المرور الخاصة بك، فقد تفقد السيطرة على معلوماتك الشخصية وتكون عرضة لتصرفات قانونية قد تُتخذ باسمك. وبالتالي، إذا تعرضت كلمة مرورك للاختراق لأي سبب، يتعين عليك إعادة تعيينها فورًا."
              : "Your password is the key to your Account, DO NOT disclose your password to anyone. If you do share your password or your personal information with others, you are solely responsible for all actions taken via your Account. If you lose control of your password, you may lose substantial control over your personal information and be subject to legally binding actions taken on your behalf. Thus, IF YOUR PASSWORD HAS BEEN COMPROMISED FOR ANY REASON, YOU MUST IMMEDIATELY RESET YOUR PASSWORD."}
          </p>
          <div className="privacy-main-header">
            {language === "ar"
              ? "12 المحتوى الذي يُنشئه المستخدم"
              : "12 USER GENERATED CONTENT"}
          </div>
          <p className="privacy-content">
            {language === "ar"
              ? "ندعوك لنشر المحتوى على منصتنا، بما في ذلك التعليقات والملاحظات والصور وأي معلومات أخرى ترغب في إتاحتها على منصتنا. إذا قمت بنشر محتوى على منصتنا، فسيكون جميع المحتوى الذي تنشره متاحًا لجميع زوار منصتنا. في حال قمت بنشر محتوى خاص بك على المنصة أو الخدمات، فقد يصبح هذا المحتوى عامًا. ولا يمكن لـ وان فوريفير منع استخدام هذه المعلومات بطريقة قد تنتهك هذه السياسة، أو القانون، أو خصوصيتك الشخصية."
              : "We invite you to post content on our Platform, including your comments, feedback, pictures, and any other information that you would like to be available on our Platform. If you post content to our Platform, all of the information that you post will be available to all visitors to our Platform. If you post your own content on our Platform or Services, your posting may become public and OneFurever cannot prevent such information from being used in a manner that may violate this Policy, the law, or your personal privacy."}
          </p>
          <div className="privacy-main-header">
            {language === "ar"
              ? "13 تغييرات على سياسة الخصوصية"
              : "13 CHANGES TO THE PRIVACY POLICY"}
          </div>
          <p className="privacy-content">
            {language === "ar"
              ? "نحتفظ بالحق في إجراء تغييرات أو تعديلات على على سياسات الخصوصية هذه في أي وقت ووفقًا لتقديرنا الخاص. إذا قامت وان فوريفر بإجراء تغييرات على سياسات الخصوصية هذه ، فسنقدم إشعارًا بهذه التغييرات، بما في ذلك تحديث تاريخ آخر تعديل في أعلى هذه السياسة. إن استمرارك في استخدام خدماتنا بعد نشر التعديلات يُعتبر قبولًا منك لهذه التغييرات أو التعديلات. لذلك، ننصح بمراجعة سياسة الخصوصية بانتظام لفهم السياسات التي تنطبق على استخدامك للخدمات."
              : "We reserve the right to make changes or modifications to these privacy policies at any time and in our sole discretion. If OneFurever makes changes to these privacy policies, we will provide notice of such changes, including by revising the date at the top of these privacy policies. Your continued use of our Services following the posting of changes or modifications will constitute your acceptance of such changes or modifications. Accordingly, you should frequently review these privacy policies to understand the policies that apply to your use of the Services."}
          </p>
          <div className="privacy-main-header">
            {language === "ar" ? ".14تواصل معنا" : "14 CONTACT US"}
          </div>
          <p className="privacy-content">
            {language === "ar"
              ? "لأي استفسارات أو مخاوف متعلقة بالخصوصية، يُرجى التواصل معنا على:"
              : "For any privacy-related concerns or questions, please reach out to:"}
          </p>
          Email: support@onefurever.net
          <p className="privacy-content">
            {language === "ar"
              ? "نحن هنا لضمان خصوصيتك وأمانك في كل خطوة."
              : "We’re here to ensure your privacy and security every step of the way."}
          </p>
        </div>
      </div>
    </>
  );
};

export default Privacy;
